<template>
    <div class="main-body">
        <div class="header">家政服务商家列表</div>
        <div class="out">


          <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">

            <el-table-column prop="name" label="商家名称" width="200" fixed></el-table-column>

            <el-table-column prop="phone" label="APP账号" width="150"></el-table-column>

            <el-table-column prop="listBusinessStaffRelDTO" label="后台账号"   width="150">
              <template slot-scope="scope">
                 <span v-for="item in scope.row.listBusinessStaffRelDTO" v-bind:key="item.BusinessStaffRelCode">
                    <div>{{item.staffName}}</div>
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="address" label="地址" width="250"></el-table-column>

            <el-table-column prop="businessType" label="商家类型" width="180">
              <template slot-scope="scope">
                <p v-if="scope.row.businessType == 1">家政服务商</p>
                <p v-if="scope.row.businessType == 2">积分兑换商</p>
                <p v-if="scope.row.businessType == 3">社区食堂商</p>
              </template>
            </el-table-column>

            <el-table-column prop="userDTO.createTime" label="创建时间" min-width="180">
              <template slot-scope="scope">
                <p>{{scope.row.userDTO.createTime | timefilters }}</p>
              </template>
            </el-table-column>


          </el-table>

          <div class="page">
            <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination small
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="pageSize"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>

        </div>


    </div>
</template>

<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";



    export default {
        name: "PageGov",
        components:{

        },

        //注册局部过滤器
        filters: {
            timefilters(val) {
                if (val == null || val == "") {
                    return "";
                } else {
                    let d = new Date(val);   //val 为表格内取到的后台时间
                    let month =
                        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
                    let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
                    let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
                    let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
                    let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
                    let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
                    return times;
                }
            }
        },

        data(){
            return{
                tableLoading:false,
                loading:false,
                dialogFormVisible:false,
                showModalAdd:false,
                showModalEdit:false,
                showModalEditStaff:false,
                bankCard:'',
                businessCode:'',

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,


              pwdDialog: false,
              password: '',

            }
        },

        created(){
            this.getList();
            this.th = this.$store.state.tableHeight+50;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val+50;
            },
        },
        methods:{

            bindCard(row){
                this.dialogFormVisible=true
                this.businessCode=row.businessCode
            },
            bindSubmit(){
                this.$confirm('是否为此商家绑定卡号为'+this.bankCard+'的银行卡?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '绑定成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消绑定'
                    });
                });
            },


            toggleModalAdd:function(){
                this.$refs.myAdd.init();
                this.showModalAdd = !this.showModalAdd;
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },


            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },


            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(isSearch) {
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableLoading=true
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Business/GovPage",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                      businessType:1,
                    }
                }).then( (response)=> {
                    _this.tableLoading=false
                    if(response.data.error == 0){
                        this.tableData = response.data.data.pageInfo.list;
                        this.totalItems = response.data.data.pageInfo.total;
                    }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },


          handlePassword(index,row) {
            this.pwdDialog = true;
            this.businessCode = row.businessCode;
            this.password = '';
          },
          editPassword() {

            if (this.password.length < 6) {
              this.$message('密码至少为六位')
              return;
            }

            this.$axios({
              method: 'post',
              url: this.$shopUrl + 'Business/EditPassword',
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),

                password: this.password,
                businessCode:this.businessCode,
              }
            }).then((response) => {
              //console.log(response);
              if (response.data.error == 0) {
                this.$message('修改成功');
                this.pwdDialog = false
              } else if (response.data.error == 1) {
                this.$message(response.data.message);
              } else {
                console.log(response.data.message);
              }

            }).catch(function (error) {
              console.log(error);
            });
          },



        }
    }
</script>

